/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PostPutSearchSettingRequestAdmin } from '../models/PostPutSearchSettingRequestAdmin';
import type { SearchSettingAdminDto } from '../models/SearchSettingAdminDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SearchSettingsService {
    /**
     * **Required Policy:** `ManageSearchSettings`
     * @returns SearchSettingAdminDto OK
     * @throws ApiError
     */
    public static postSearchSettingByServiceIdAdmin({
        serviceId,
        requestBody,
    }: {
        serviceId: number,
        requestBody?: PostPutSearchSettingRequestAdmin,
    }): CancelablePromise<SearchSettingAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/searchsettings/service/{serviceId}',
            path: {
                'serviceId': serviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSearchSettings`
     * @returns SearchSettingAdminDto OK
     * @throws ApiError
     */
    public static getSearchSettingAdmin({
        serviceId,
    }: {
        serviceId: number,
    }): CancelablePromise<SearchSettingAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/searchsettings/service/{serviceId}',
            path: {
                'serviceId': serviceId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageSearchSettings`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteSearchSettingAdmin({
        serviceId,
    }: {
        serviceId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/searchsettings/service/{serviceId}',
            path: {
                'serviceId': serviceId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
